import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { 
  BookOpen, 
  PlayCircle,
  Calendar,
  User,
  Bell,
  Search,
  GraduationCap,
  MessageSquare
} from 'lucide-react';

const Layout = () => {
  const location = useLocation();

  const navItems = [
    { icon: BookOpen, label: 'Dashboard', path: '/dashboard' },
    { icon: GraduationCap, label: 'Course Catalog', path: '/courses' },
    { icon: PlayCircle, label: 'My Courses', path: '/my-courses' },
    { icon: MessageSquare, label: 'Community', path: '/community' },
    { icon: Calendar, label: 'Schedule', path: '/schedule' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar */}
      <nav className="bg-white border-b border-gray-200 fixed w-full z-30 top-0">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center gap-12">
              <Link to="/dashboard" className="flex items-center gap-3">
                <BookOpen className="text-navy-600" size={32} />
                <span className="text-xl font-bold text-navy-900">Teampace Academy</span>
              </Link>
              
              <div className="relative hidden md:block">
                <input
                  type="text"
                  placeholder="Search courses..."
                  className="w-96 px-4 py-2 pl-10 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-navy-600"
                />
                <Search className="absolute left-3 top-2.5 text-gray-400" size={20} />
              </div>
            </div>

            <div className="flex items-center gap-4">
              <button 
                className="p-2 hover:bg-gray-100 rounded-lg relative"
                aria-label="Notifications"
              >
                <Bell size={20} className="text-gray-600" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>
              <div className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                <img
                  src="/api/placeholder/32/32"
                  alt="User avatar"
                  className="w-8 h-8 rounded-full"
                />
                <span className="font-medium text-gray-700">John Doe</span>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <aside className="fixed w-64 bg-white border-r border-gray-200 top-16 bottom-0 flex flex-col">
        {/* Main navigation */}
        <div className="flex-1 overflow-y-auto p-4 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                location.pathname === item.path
                  ? 'bg-navy-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <item.icon size={20} />
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </div>

        {/* Profile link at bottom */}
        <div className="p-4 border-t border-gray-200 mt-auto">
          <Link
            to="/profile"
            className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
              location.pathname === '/profile'
                ? 'bg-navy-600 text-white' 
                : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            <User size={20} />
            <span className="font-medium">Profile</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="pl-64 pt-16">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;